import { DRAWER_TYPES } from '../../components';
import { resolveDeclinationStatus } from '../../components/drawers/DeclinationReasonsDrawer/DeclinationReasons.shared';

export const buildSendoutsDrawerNavigator = ({ openDrawer, jobOrder, setSendoverActiveStatus }) => {
  const nav = {};

  const openDuplicates = ({ candidate }) => {
    openDrawer(DRAWER_TYPES.Duplicates, {
      jobOrder,
      candidate,
      onOpenSendoutDetails: nav.openSendoutDetails,
      onOpenSendoverDetails: nav.openSendoverDetails
    });
  };

  nav.openCreateCall = () => {
    openDrawer(DRAWER_TYPES.CreateCall, { jobOrder });
  };

  nav.openCallList = () => {
    openDrawer(DRAWER_TYPES.CallList, {
      // TODO: CallList/CreateCall are placeholders for now
      onCreateCall: () => nav.openCreateCall(null),
      onEditCall: callId => nav.openCreateCall(callId)
    });
  };

  nav.openSendoutInterviewDebriefDetails = ({ interviewId, participant }) => {
    openDrawer(DRAWER_TYPES.SendoutInterviewDebriefDetails, { interviewId, participant });
  };

  nav.openSendoutInterviewDebriefEdit = ({ interviewId, participant }) => {
    openDrawer(DRAWER_TYPES.SendoutInterviewDebriefEdit, { interviewId, participant });
  };

  nav.openSendoutInterviewDetails = ({ interviewId }) => {
    openDrawer(DRAWER_TYPES.SendoutInterviewDetails, {
      interviewId,
      onViewDebrief: participant =>
        nav.openSendoutInterviewDebriefDetails({ interviewId, participant }),
      onEditDebrief: participant =>
        nav.openSendoutInterviewDebriefEdit({ interviewId, participant })
    });
  };

  nav.openSendoutDetails = ({ sendoutId }) => {
    openDrawer(DRAWER_TYPES.SendoutDetails, {
      sendoutId,
      jobOrder,
      onOpenCalls: nav.openCallList,
      onEditDetails: refreshData =>
        openDrawer(DRAWER_TYPES.SendoutDetailsEdit, {
          sendoutId,
          jobOrder,
          onCustomSubmitSuccess: refreshData
        }),
      onScheduleInterview: refreshInterviews =>
        openDrawer(DRAWER_TYPES.CreateSendoutInterview, {
          sendoutId,
          onCustomSubmitSuccess: refreshInterviews
        }),
      onViewInterviewDetails: ({ interviewId }) => nav.openSendoutInterviewDetails({ interviewId })
    });
  };

  nav.openSendoutDeclinationReasons = ({ initialValues, sendoutId, status, refreshData }) => {
    if (!resolveDeclinationStatus(status?.id)) return;

    openDrawer(DRAWER_TYPES.SendoutDeclinationReasons, {
      sendoutId,
      status,
      initialValues,
      onCustomSubmitSuccess: refreshData
    });
  };

  nav.openSendoverDeclinationReasons = ({ initialValues, sendoverId, status, refreshData }) => {
    if (!resolveDeclinationStatus(status?.id)) return;

    openDrawer(DRAWER_TYPES.SendoverDeclinationReasons, {
      sendoverId,
      status,
      initialValues,
      onCustomSubmitSuccess: refreshData
    });
  };

  nav.openSendoverDetails = ({ sendoverId }) => {
    openDrawer(DRAWER_TYPES.SendoverDetails, {
      sendoverId,
      onConvertToSendout: nav.openConvertSendoverToSendout,
      onOpenDeclinationReasons: nav.openSendoverDeclinationReasons,
      onSetActiveStatus: setSendoverActiveStatus
    });
  };

  nav.openConvertSendoverToSendout = ({ sendover, switchType }) => {
    openDrawer(DRAWER_TYPES.ConvertSendoverToSendout, {
      sendover,
      switchType,
      jobOrderId: jobOrder?.id,
      onViewDuplicates: openDuplicates
    });
  };

  nav.openCreateSendout = () => {
    openDrawer(DRAWER_TYPES.CreateSendout, {
      jobOrderId: jobOrder?.id,
      onSaveAsDraft: () => {
        openDrawer(DRAWER_TYPES.Drafts, {
          jobOrderId: jobOrder?.id
        });
      },
      onViewDuplicates: openDuplicates
    });
  };

  nav.openCreateSendover = () => {
    openDrawer(DRAWER_TYPES.CreateSendover, {
      jobOrderId: jobOrder?.id,
      onViewDuplicates: openDuplicates
    });
  };

  nav.openDrafts = () => {
    openDrawer(DRAWER_TYPES.Drafts, {
      onSelectDraft: draft =>
        // TODO: implement draft logic to identify type of draft
        openDrawer(
          draft?.type === 'sendover' ? DRAWER_TYPES.CreateSendover : DRAWER_TYPES.CreateSendout,
          {
            jobOrderId: jobOrder?.id,
            onOpenCalls: nav.openCallList
          }
        )
    });
  };

  return nav;
};
